import dayjs from 'dayjs';
import type { AccountStats } from '../../hooks/api/useAccountStats';

export type AccountStatus = 'active' | 'disabled' | 'trial';

export const isAccountExpired = (expirationDate?: string): boolean => {
  if (!expirationDate) return false;
  return dayjs(expirationDate).isBefore(dayjs());
};

/**
 * Disabling an account backdates its contract expiry, so a disabled account and
 * an expired one look the same and both count as disabled, trial or not.
 */
export const getAccountStatus = (account: AccountStats): AccountStatus => {
  if (isAccountExpired(account.contract_expiration_date)) return 'disabled';
  return account.trial ? 'trial' : 'active';
};
